import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import GoogleAnalytics from "./components/GoogleAnalytics";
import Landing from "./pages/Landing";
import ScanProgress from "./pages/ScanProgress";
import Report from "./pages/Report";
import Pricing from "./pages/Pricing";
import RecentReports from "./pages/RecentReports";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyAccount from "./pages/VerifyAccount";
import LegalRedirect from "./pages/LegalRedirect";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SelfBadge from "./components/SelfBadge";
import InstallPrompt from "./components/InstallPrompt";
import { AuthProvider } from "./lib/auth";

/**
 * Detects the OAuth fragment (#session_id=...) synchronously during render
 * — useEffect-based handling runs too late and races the AuthProvider's
 * /auth/me check.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/scan/:scanId" element={<ScanProgress />} />
      <Route path="/report/:domain" element={<Report />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/recent" element={<RecentReports />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/verify/:token" element={<VerifyEmail />} />
      <Route path="/verify-email/:token" element={<VerifyAccount />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/privacy" element={<LegalRedirect slug="privacy" />} />
      <Route path="/terms" element={<LegalRedirect slug="terms" />} />
      <Route path="/cookies" element={<LegalRedirect slug="cookies" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <GoogleAnalytics />
          <Navbar />
          <AppRouter />
          <Footer />
          <SelfBadge />
          <InstallPrompt />
          <Toaster richColors position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
